// Externe Bibliotheken
import React, { Component } from 'react';

// Komponenten
import Button from '@/comp/button/button.tsx';
import OverlayModal from '@/comp/overlayModal/overlayModal.jsx';
import { Icon } from '@/comp/icon/icon.tsx';
import { iconMapping } from './../../index.jsx';

// Styles
import './claimUploadForm.scss';
import { Tooltip } from '@/comp/toolTip/tooltip.tsx';

class ClaimUploadForm extends Component {
    state = {
        entryPoints: [],
        activeSubElements: {},
        formValid: false,
        formSubmit: false,
        dataReturnTree: {},
        uploadElements: {},
        fileList: {},
        fileErrors: {},
    };

    uploadForm = {
        fault: 'Mängelprotokoll',
        check24: 'Einzelverbindungsnachweis zu CHECK24',
        luggage: 'Mängelprotokoll/PIR der Fluggesellschaft',
        general: 'Fotos, Videos, Rechnungen, Zahlungsbelege',
    };

    uploadDescription = {
        fault: 'Für gewöhnlich ist das Mängelprotokoll ein A4-Zettel, auf dem bestimmte Daten wie Name und Adresse der Unterkunft, Erstellungsdatum und Mängel protokolliert werden. Eine bestimmte Form ist für das Mängelprotokoll nicht vorgeschrieben. Wichtig ist, dass alles vollständig sowie detailliert und unmissverständlich formuliert ist.',
        check24:
            'Bei einem Einzelverbindungsnachweis handelt es sich um eine aufgeschlüsselte Übersicht aller Ihrer getätigten Anrufe und SMS. Diese Informationen können Sie bei Ihrem Telefonanbieter einholen.',
        luggage:
            'Kommt es am Flughafen zu Beschädigung oder Verlust des Gepäcks, sind Sie angehalten, dies umgehend am Lost & Found-Schalter zu melden. Dort erhalten Sie als Bestätigung eine Referenznummer (PIR = Property Irregularity Report). Diese Referenznummer ist zwingend notwendig, um den Bearbeitungsstand der Gepäckunregelmäßigkeit international verfolgen zu können.',
        general:
            'Als Zahlungsnachweis werden sowohl Kassenbons, Bestätigungen einer durchgeführten Überweisung, Kreditkartenabrechnungen und andere Belegarten anerkannt.',
    };

    uploadNames = {
        'Strand-Poolliegen': 'Strand-/Poolliegen',
        WLANInternet: 'Wlan/Internet',
    };

    constructor(props) {
        super(props);
        this.TreeSection = this.TreeSection.bind(this);
        this.UploadField = this.UploadField.bind(this);
        this.UploadFileList = this.UploadFileList.bind(this);
        this.WarningModal = this.WarningModal.bind(this);

        this.state.dataReturnTree = this.props.dataReturnTree;
        this.state.dataTree = this.props.dataTree;
    }

    componentDidMount() {
        if (this.props.uploadElements !== undefined) {
            this.setState({ uploadElements: this.props.uploadElements });
        }
        if (this.props.fileList !== undefined) {
            this.setState({ fileList: this.props.fileList });
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ formSubmit: true });

        if (this.validateForm()) {
            this.setState({ formValid: true }, () => {
                this.setFileList(this.state.fileList);
                if (window.$affiliate === 'ch24' && typeof this.props.contactData?.email === 'string') {
                    this.props.changeStep(3);
                } else {
                    this.props.changeStep(2);
                }
            });
        }
    }

    setFileList(props) {
        this.props.setFileList(props);
    }

    validateForm() {
        let validateForm = false;

        Object.keys(this.state.fileList).forEach((uploadField) => {
            if (this.state.fileList[uploadField].length > 0) {
                validateForm = true;
            }
        });
        return validateForm;
    }

    dropHandler = (e) => {
        e.persist();
        e.target.classList.remove('dragOver');

        // Prevent default behavior (Prevent file from being opened)
        e.preventDefault();
        let elem = e.currentTarget.querySelector('input');
        this.changeFiles(e.dataTransfer.files, elem);
    };

    dragOverHandler = (e) => {
        // Prevent default behavior (Prevent file from being opened)
        e.preventDefault(e);

        e.target.classList.add('dragOver');
    };

    dragLeaveHandler = (e) => {
        e.target.classList.remove('dragOver');
    };

    changeFiles = (fileList, elem) => {
        this.checkFiles(fileList, elem.id)
            .then(() => {
                for (const file of fileList) {
                    this.setState((state) => {
                        state.fileErrors[elem.id + '_' + elem.name] = '';
                        return { fileErrors: state.fileErrors };
                    });

                    this.setState((state) => {
                        const files = state.fileList;
                        files[elem.id].push(file);
                        return { fileList: files };
                    });
                }
            })
            .catch(() => {});
    };

    handleUploadFile = (e, type) => {
        e.persist();
        this.setState((state) => {
            state.fileErrors[type] = false;

            return { fileErrors: state.fileErrors };
        });

        let elem = e.currentTarget.querySelector('input');
        this.changeFiles(elem.files, elem);
    };

    checkFiles = (files, identifier) => {
        let promises = [];

        for (const file of files) {
            if (file.size > 4000000) {
                this.setState((state) => {
                    state.fileErrors[identifier] =
                        'Die Datei ist zu groß. Bitte laden Sie eine Datei hoch, die maximal 4mb groß ist.';
                    return { fileErrors: state.fileErrors };
                });
                promises.push(Promise.reject());
                continue;
            }
            promises.push(
                this.getFileHeader(file).then((header) => {
                    if (!!~ClaimUploadForm.findMimeTypeForHeader(header).search(/image\/|video\/|application\/pdf/gm)) {
                        return Promise.resolve();
                    }
                    this.setState((state) => {
                        state.fileErrors[identifier] =
                            'Der Dateityp ist nicht erlaubt. Bitte laden Sie Ihren Nachweis im Format .pdf, .jpg, .png, .mp4, .mov hoch.';
                        return { fileErrors: state.fileErrors };
                    });

                    return Promise.reject();
                })
            );
        }

        return Promise.all(promises);
    };

    getFileHeader = (file) => {
        return new Promise((resolve) => {
            let fileReader = new FileReader();
            fileReader.onloadend = function (event) {
                let subarray = new Uint8Array(event.target.result).subarray(0, 4);
                let header = '';
                for (let i = 0; i < subarray.length; i++) {
                    header += subarray[i].toString(16);
                }
                return resolve(header);
            };
            fileReader.readAsArrayBuffer(file);
        });
    };

    static findMimeTypeForHeader(headerString) {
        switch (headerString) {
            case '89504e47':
                return 'image/png';
            case '47494638':
                return 'image/gif';
            case 'ffd8ffee':
            case 'ffd8ffe0':
            case 'ffd8ffe1':
            case 'ffd8ffe2':
            case 'ffd8ffe3':
            case 'ffd8ffe8':
                return 'image/jpeg';
            case '424d':
                return 'image/bmp';
            case '00000100':
                return 'image/vnd.microsoft.icon';
            case '492049':
            case '49492a00':
            case '4d4d002a':
            case '4d4d002b':
                return 'image/tiff';
            case '52494646':
                return 'video/x-msvideo';
            case '66747970':
            case '00020':
            case '00014':
                return 'video/mp4';
            case '000001ba':
            case '000001b3':
                return 'video/mpeg';
            case '4F676753':
                return 'video/ogg';
            case '1a45dfa3':
                return 'video/webm';
            case '25504446':
            case '58354f21':
                return 'application/pdf';
            default:
                return 'unknown';
        }
    }

    removeFile = (props, item) => {
        let fileList = this.state.fileList[props.subElement];
        document.getElementById(props.subElement).value = '';
        fileList.splice(fileList.indexOf(item), 1);
        this.setState((state) => {
            state.fileList[props.subElement] = fileList;
            return state.fileList[props.subElement];
        });
    };

    closeModal = (props, selection) => {
        if (selection === true) {
            this.props.setFileList(this.state.fileList);
            if (window.$affiliate === 'ch24' && typeof this.props.contactData?.email === 'string') {
                this.props.changeStep(3);
            } else {
                this.props.changeStep(2);
            }
        } else {
            this.setState((state) => {
                state.formSubmit = false;
                return state;
            });
        }
    };

    render() {
        const mainTreeSections = [];
        if (this.state.dataReturnTree && this.state.dataTree) {
            Object.keys(this.state.dataReturnTree).forEach((entryPoint) => {
                mainTreeSections.push(
                    <this.TreeSection
                        key={this.state.dataTree.EntryPoint[entryPoint].key + 'section'}
                        tree={this.state.dataTree.EntryPoint[entryPoint]}
                        treeKey={this.state.dataTree.EntryPoint[entryPoint].key}
                        returnTree={this.state.dataReturnTree}
                    />
                );
            });
        }

        return (
            <>
                <section className="content-wrapper">
                    <div className="intro row">
                        <div className="intro-title">
                            <h1>Ihre Nachweise</h1>
                        </div>
                        <div className="intro-text">
                            <p>
                                Damit wir Ihre Reklamation so schnell wie möglich bearbeiten können, ist es für uns sehr
                                wichtig, dass Sie
                                <br /> hier vollständige und aussagekräftige Nachweise (zum Beispiel Fotos, Videos oder
                                Rechnungen) hochladen.
                                <br /> Ohne diese Nachweise besteht leider nur eine geringe Wahrscheinlichkeit auf eine
                                Erstattung.
                            </p>
                        </div>
                    </div>
                </section>

                {/* FORM */}
                <form onSubmit={(event) => this.handleSubmit(event)}>
                    <section className="section-upload-step content-wrapper">{mainTreeSections}</section>

                    <section className="section-submit">
                        <div className="container">
                            <div className="row button-container">
                                <button
                                    className="button-back"
                                    onClick={() => {
                                        if (this.state.fileList) {
                                            this.setFileList(this.state.fileList);
                                        }
                                        this.props.changeStep(0);
                                    }}>
                                    <Icon name="keyboardArrowLeft" ariaHidden />
                                    Zurück zum Formular
                                </button>
                                <this.Submit key="submit" />
                            </div>
                        </div>
                    </section>
                </form>

                {!this.state.formValid && this.state.formSubmit && <this.WarningModal />}
            </>
        );
    }

    // Components

    UploadFileList(props) {
        let fileList = [];

        if (this.state.fileList[props.subElement] !== undefined) {
            this.state.fileList[props.subElement].forEach((item, index) => {
                fileList.push(
                    <div className="file" key={index}>
                        <span
                            className="icon-delete-file"
                            aria-label={`datei ${item.name} entfernen`}
                            onClick={() => this.removeFile(props, item)}>
                            <Icon name="delete" ariaHidden />
                        </span>
                        <span className="file-name">{item.name}</span>
                    </div>
                );
            });
        }
        return fileList;
    }

    WarningModal() {
        return (
            <OverlayModal
                name="claim-form"
                scrollable={false}
                showLogo={true}
                toggleModal={(props) => this.closeModal(props, false)}>
                <div>
                    <p className="modal-title">Möchten Sie wirklich fortfahren?</p>
                    <p className="modal-text">
                        Es scheint so, als hätten Sie noch keine Nachweise hochgeladen. Sie können die Reklamation
                        dennoch fortführen, aber wir möchten Sie an dieser Stelle darauf hinweisen, dass ohne diese
                        Nachweise leider nur eine geringe Wahrscheinlichkeit auf eine Erstattung besteht.
                    </p>
                </div>

                <div className="modal-button-container">
                    <Button
                        handleClick={(props) => this.closeModal(props, false)}
                        label="Nein, jetzt Nachweise hochladen"
                    />
                    <Button
                        classList="button-white"
                        handleClick={(props) => this.closeModal(props, true)}
                        label="Ja, ohne Nachweise fortfahren"
                    />
                </div>
            </OverlayModal>
        );
    }

    UploadField(props) {
        const uploadType = this.uploadForm[props.uploadType];
        const uploadDescription = this.uploadDescription[props.uploadType];
        const uniqueKey = this.props.escapeString(props.treeKey) + '_' + props.uploadType;

        let $this = this;

        if (this.state.fileList[uniqueKey] === undefined) {
            $this.state.fileList[uniqueKey] = [];
        }

        return (
            <>
                <div className="upload-container" key={uniqueKey}>
                    <div className="upload-title">
                        <div className="heading">
                            <div className="text-bold">
                                {uploadType}
                                <Tooltip
                                    classList="info-layer"
                                    iconSize={24}
                                    placement={window.$browserInfo.device === 'mobile' ? 'bottom' : 'right'}>
                                    {uploadDescription}
                                </Tooltip>
                            </div>
                        </div>
                        <p className="enabled-files">Erlaubte Dateitypen: .pdf, .jpg, .png, .mp4, .mov</p>
                    </div>
                    <div className="upload-field-container">
                        <div
                            className="upload-field"
                            onClick={() => document.getElementById(uniqueKey).click()}
                            onDrop={this.dropHandler}
                            onDragOver={this.dragOverHandler}
                            onChange={(e) => this.handleUploadFile(e, uniqueKey)}
                            onDragLeave={this.dragLeaveHandler}>
                            <span className="icon-upload-file"></span>
                            <p>Nachweise für Upload auswählen</p>
                            <input id={uniqueKey} type="file" name={uniqueKey} multiple />
                        </div>
                        <div className="upload-files-list">
                            <this.UploadFileList subElement={uniqueKey} uploadElement={uniqueKey} />
                        </div>
                    </div>
                </div>
                {this.state.fileErrors[uniqueKey] && <div className="error">{this.state.fileErrors[uniqueKey]}</div>}
            </>
        );
    }

    Submit() {
        return (
            <>
                <Button
                    type="submit"
                    label={window.$affiliate === 'ch24' ? 'Weiter zur Zusammenfassung' : 'Weiter zu den Kontaktdaten'}
                />
            </>
        );
    }

    TreeSection(args) {
        const tree = args.tree;
        const treeKey = args.treeKey;
        const returnTree = args.returnTree;

        const elements = [];
        if (treeKey === 'Others' && Object.keys(returnTree[treeKey]).length < 2) {
            if (this.state.uploadElements[treeKey]) {
                this.state.uploadElements[treeKey].forEach((uploadElement) => {
                    elements.push(
                        <this.UploadField
                            key={treeKey + '_' + this.props.escapeString(uploadElement)}
                            treeKey={treeKey}
                            uploadType={uploadElement}
                        />
                    );
                });
            }

            elements.push(
                <this.UploadField
                    key={`${this.props.escapeString(treeKey)} _general`}
                    treeKey={treeKey}
                    uploadType="general"
                />
            );
        }

        Object.keys(returnTree[treeKey]).forEach((uploadElement, i) => {
            if (uploadElement === 'questions') return;

            let parsedUploadElement = this.props.escapeString(uploadElement);

            elements.push(
                <h3 key={i} className="categorySubText">
                    {this.uploadNames[uploadElement] || uploadElement.replaceAll('-', ' ')}
                </h3>
            );
            if (returnTree[treeKey][uploadElement] && Object.keys(returnTree[treeKey][uploadElement]).length > 1) {
                Object.keys(returnTree[treeKey][uploadElement]).forEach((subElement) => {
                    if (subElement === 'questions') return;

                    if (
                        returnTree[treeKey][uploadElement] &&
                        Object.keys(returnTree[treeKey][uploadElement]).length > 1
                    ) {
                        elements.push(<h3 key={i + subElement}>{this.uploadNames[subElement] || subElement}</h3>);
                    }

                    Object.keys(this.state.uploadElements).forEach((item) => {
                        let pieces = item.split('_');
                        if (subElement === pieces[2] && treeKey === pieces[0]) {
                            this.state.uploadElements[item].forEach((uploadType) => {
                                elements.push(
                                    <this.UploadField
                                        key={item + '_' + uploadType}
                                        treeKey={item}
                                        uploadType={uploadType}
                                        uploadTitle={parsedUploadElement}
                                    />
                                );
                            });
                        }
                    });

                    if (
                        returnTree[treeKey][uploadElement] &&
                        Object.keys(returnTree[treeKey][uploadElement]).length > 1
                    ) {
                        elements.push(
                            <this.UploadField
                                key={`${treeKey}_${parsedUploadElement}_${subElement}_general`}
                                treeKey={treeKey + '_' + parsedUploadElement + '_' + subElement}
                                uploadType="general"
                            />
                        );
                    }
                });
            } else {
                Object.keys(this.state.uploadElements).forEach((item) => {
                    let pieces = item.split('_');
                    this.state.uploadElements[item].forEach((uploadType) => {
                        if (uploadElement === pieces[1] && treeKey === pieces[0]) {
                            elements.push(
                                <this.UploadField
                                    key={item + '_' + uploadType}
                                    treeKey={item}
                                    uploadType={uploadType}
                                    uploadTitle={parsedUploadElement}
                                />
                            );
                        }
                    });
                });
                elements.push(
                    <this.UploadField
                        key={`${treeKey}_${parsedUploadElement}_general`}
                        treeKey={treeKey + '_' + parsedUploadElement}
                        uploadType="general"
                    />
                );
            }
        });

        return (
            <div className="article" key={treeKey}>
                <h2 className={'categoryText active icon-' + tree.key}>
                    <Icon className={`icon-${tree.key}`} name={iconMapping[tree.key]} size={30} ariaHidden />
                    {tree.name}
                </h2>
                <div className="subbox panel">{elements}</div>
            </div>
        );
    }
}

export default ClaimUploadForm;
